<template>
  <div class="col-12">
    <vue-headful :title="`Users • ${$store.state.settings.settings.site_name}`" />
    <h1>Users</h1>
    <table-search-and-pagination
      :table-data="users"
      @dataUpdated="queriedData = $event">
      <div
        slot="header"
        class="flex-end">
        <base-button
          type="primary"
          @click="addUserModal = true">
          Add User
        </base-button>
      </div>
      <el-table
        v-if="users.length"
        v-sticky-theader
        :data="queriedData"
        @row-click="editUser">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
          :show-overflow-tooltip="true" />
      </el-table>
    </table-search-and-pagination>
    <modal
      :show.sync="addUserModal"
      body-classes="p-0"
      modal-classes="modal-sm">
      <card
        class="mb-0 card-form">
        <template slot="header">
          <h2 class="modal-title">Add User</h2>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="addUserModal = false">
            <i class="tim-icons icon-simple-remove" />
          </button>
        </template>
        <user-add-form
          :user-roles="userRoles"
          :password-min-length="passwordMinLength"
          :reset="!addUserModal"
          :user-added="userAdded"
          @close="addUserModal = false"
          @addUser="addUser" />
      </card>
    </modal>
  </div>
</template>
<script>
import { Modal } from 'src/components/UI';
import TableSearchAndPagination from 'src/components/TableSearchAndPagination';
import UserAddForm from './UserAddForm.vue';

export default {
  name: 'Users',
  components: {
    UserAddForm,
    Modal,
    TableSearchAndPagination,
  },
  props: {
    users: {
      type: Array,
      required: true,
    },
    userRoles: {
      type: Array,
      required: true,
    },
    passwordMinLength: {
      type: Number,
      required: true,
    },
    userAdded: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      queriedData: [],
      addUserModal: false,
      tableColumns: [
        {
          prop: 'full_name',
          label: 'Name',
        },
        {
          prop: 'username',
          label: 'Username',
        },
        {
          prop: 'role',
          label: 'Role',
        },
        {
          prop: 'status',
          label: 'Status',
        },
      ],
    };
  },
  methods: {
    editUser(row) {
      this.$router.push(`/user/${row.id}`);
    },
    addUser(user) {
      this.$emit('addUser', user);
    },
  },
};
</script>
